module.exports = __webpack_public_path__ + "img/label-printer.1ba1720d.svg";